import React, { useState } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import swal from "sweetalert";

function Admin() {
  const navigate = useNavigate();
  const [active, setActive] = useState("onco");
  const cookies = new Cookies();
  const role = window.localStorage.getItem("role");

  const onco = () => {
    setActive("onco");
  };
  const gemo = () => {
    setActive("gemo");
  };
  const admin = () => {
    setActive("admin");
  };

  const handleLogOut = () => {
    swal({
      title: "Are you sure?",
      text: " You will log out",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        cookies.remove("token");
        localStorage.removeItem("role");
        navigate("/");
        window.location.reload(false);
      }
    });
  };

  return (
    <div className=" admin">
      <div>
        <Link
          onClick={onco}
          className={active === "onco" ? "active" : ""}
          to="/"
        >
          RIO va RIATM
        </Link>
        <Link
          onClick={gemo}
          className={active === "gemo" ? "active" : ""}
          to="/adminGemo"
        >
          BGO va KIM
        </Link>
        {role === "SuperAdmin" ? (
          <Link
            onClick={admin}
            className={active === "admin" ? "active" : ""}
            to="/superAdmin"
          >
            Admin qo`shish
          </Link>
        ) : (
          ""
        )}
      </div>
      <Button onClick={handleLogOut} type="primary" danger>
        Log-out
      </Button>
    </div>
  );
}

export default Admin;
